import React from 'react';

type RequiredFieldErrorProps = { message?: string };

const RequiredFieldError = ({ message }: RequiredFieldErrorProps) => (
  <div className="invalid-feedback">{message || 'Pole wymagane'}</div>
);

export default RequiredFieldError;
